import React from 'react'
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { Tooltip } from '@mui/material'

const SupplyBillCountItemsShort = ({ items }) => {
  return (
    <div className='commentShortOne'>
        <Tooltip title='Позицій'>
            <ClearAllIcon />
        </Tooltip>
        <p>
            {
                items ? items.length : ''
            }
        </p>
    </div>
  )
}

export default SupplyBillCountItemsShort